const _version = "2.13.2"
function version() {
    return _version
}
export default version
